import { CalculationResult, DegreeType, Faculty, Lang, MiluimPeriod, RightType } from "../types/general";
import * as config from './config'

import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { hakalotTerms } from "../terms/hakalotTerms";
import { calcRightsForDental } from "./dentalCalcRights";
import { MalagRights, MalagTimePeriods } from "./config";
import { addFinalHakalot, calcRightsAccordingDays24_25, getOverlappingDaysNumByRange } from "./extendAppUtils"
const moment = extendMoment(Moment);

export function calcRights(isInMiluim: boolean, degreeType: DegreeType, miluimRanges: MiluimPeriod[]): CalculationResult[] {
    if (getFaculty() === Faculty.DENTAL) {
        return calcRightsForDental(isInMiluim, degreeType, miluimRanges);
    }
    if (getFaculty() === Faculty.BSCHOOL) {
        // bney zoog of "maslul muatz" or "musmach" of Bschool === bney zoog of usual "musmach"
        if (!isInMiluim && (degreeType === DegreeType.BschoolMaslulMuatz || degreeType === DegreeType.BschoolMusmach)) {
            return calcRightsAccordingDays(isInMiluim, DegreeType.Musmach, miluimRanges);
        }
    }
    return calcRightsAccordingDays(isInMiluim, degreeType, miluimRanges);
}

export function calcRightsAccordingDays(isInMiluim: boolean, degreeType: DegreeType, miluimRanges: MiluimPeriod[]): CalculationResult[] {
    var totalMiluimDaysIn23_24 = getOverlappingDaysNumByRange(miluimRanges, config.YEAR_23_24_PERIOD);

    // let ovelapingSemesterDays = getOverlappingDaysNum(miluimRanges);
    let overlapingShnatLimudimDays = getOverlappingDaysNum(miluimRanges, true) // used for exams-hakalot for semster B too.

    let y = 0;
    let hakalotArray = [] as CalculationResult[];

    if (totalMiluimDaysIn23_24 >= 10 && isInMiluim) {
        hakalotArray.push(...get10DaysHakala(degreeType));
    }

    if (isInMiluim && totalMiluimDaysIn23_24 >= 28) {
        hakalotArray.push(...get28DaysHakala());
    }

    if (isInMiluim && (degreeType === DegreeType.Boger || degreeType === DegreeType.RefuaChishuvit) && totalMiluimDaysIn23_24 >= 200) {
        hakalotArray.push(...get200DaysHakala(degreeType));
    }

    if (totalMiluimDaysIn23_24 >= 42 && overlapingShnatLimudimDays >= 42) { // not with another case of 50 days
        // push case of 3 weeks 1
        hakalotArray.push(...getWeeksOneHakala(isInMiluim, degreeType))
        hakalotArray.push(...getWeeksTwoHakala(isInMiluim, degreeType))
        y = 42;
    } else if (21 <= totalMiluimDaysIn23_24 && overlapingShnatLimudimDays >= 21) {
        // push case of 3 weeks 1
        hakalotArray.push(...getWeeksOneHakala(isInMiluim, degreeType))
        y = 21;
    }

    let z = totalMiluimDaysIn23_24 - y; // days reminds
    if (z >= 50) {
        // push case of 50 days
        hakalotArray.push(...get50DaysHakala(isInMiluim, degreeType))
    }

    if (isInMiluim && overlapingShnatLimudimDays >= 21) {
        let getHighestGrade = {
            sum: -1,
            reason: hakalotTerms.THREE_WEEKS_SHNAT_LIMNUDIM_REASON,
            type: RightType.HighestGrade
        }
        hakalotArray.push(getHighestGrade)
    }

    let binaryArr = hakalotArray.filter(c => c.type === RightType.Course);

    // remove all binaryCousre hakalot for take the highest binary
    hakalotArray = hakalotArray.filter(c => c.type !== RightType.Course);
    hakalotArray = hakalotArray.filter(c => c.sum !== 0);

    // takes the highest binary course number hakala:
    let max = 0;
    let maxBin = null as CalculationResult | null;
    binaryArr.forEach(b => {
        if (b.sum > max) {
            max = b.sum;
            maxBin = b;
        }
    })

    if (maxBin) {
        hakalotArray.push(maxBin);
    }

    if (hakalotArray.find(c => c.type === RightType.HighestGrade)) {
        hakalotArray = hakalotArray.filter(c => c.type !== RightType.ExamDoesntCount)
    }

    if (degreeType == DegreeType.Boger || degreeType == DegreeType.RefuaChishuvit) {
        hakalotArray = checkForMalagHakalot(totalMiluimDaysIn23_24, hakalotArray);
    }

    hakalotArray.sort((a, b) => a.type - b.type)
    
    let hakalotArray24_25 = calcRightsAccordingDays24_25(isInMiluim, degreeType, miluimRanges);
    
    hakalotArray = hakalotArray24_25.concat(hakalotArray);

    // להוריד "הערכה חלופית", "פטור מנוכחות" ו"תרגילי בית" במדעי המחשב
    if (getFaculty() === Faculty.CSE) {
        hakalotArray = hakalotArray.filter(h => h.type !== RightType.IntermediateAssignmentsPtor && 
        h.type !== RightType.PtorMandatoryAttendance && h.type !== RightType.AlternativeAssessment);
    }

    hakalotArray = addFinalHakalot(hakalotArray, degreeType);

    return hakalotArray;
}

export function checkForMalagHakalot(totalMiluimDays: number, hakalotArray: CalculationResult[]): CalculationResult[] {
    let ptorNekutorZcootRectorHakalot = hakalotArray.filter(c => c.type === RightType.NekudotZehut || c.type === RightType.AvneyPina);
    let binaryCourseRectorHakalot = hakalotArray.find(c => c.type === RightType.Course);
    
    let protNekudotZcootRectorSum = 0;
    let binaryCourseRectorNum = 0;
    
    ptorNekutorZcootRectorHakalot.forEach(c => protNekudotZcootRectorSum += c.sum);
    if (binaryCourseRectorHakalot) {
        binaryCourseRectorNum = binaryCourseRectorHakalot.sum;
    }
        
    let ptorNekudotZehutMalagHakala = getPtorNekudotZehutMalag(totalMiluimDays);
    let ptorNekutorZcootMalagHakalaSum = ptorNekudotZehutMalagHakala?.sum;
    let binaryCourseMalagHakala = getBinaryCourseNumberMalag(totalMiluimDays);
    let binaryCourseMalagHakalaNum = binaryCourseMalagHakala?.sum;

    let newHakalotArray = hakalotArray;
    if (ptorNekudotZehutMalagHakala && ptorNekutorZcootMalagHakalaSum) {
        if (ptorNekutorZcootMalagHakalaSum > protNekudotZcootRectorSum) {
        // newHakalotArray = hakalotArray.filter(c => c.type !== RightType.NekudotZehut);
        // newHakalotArray.push(ptorNekudotZehutMalagHakala!)
            ptorNekudotZehutMalagHakala.isGreater = true;
        } else if(ptorNekutorZcootMalagHakalaSum < protNekudotZcootRectorSum) {
            newHakalotArray.forEach(c => {
                if(c.type === RightType.NekudotZehut || c.type === RightType.AvneyPina) {
                    c.isGreater = true;
                } 
            }) 
        }
    }

    if (ptorNekutorZcootMalagHakalaSum) {
        newHakalotArray.push(ptorNekudotZehutMalagHakala!)
    }

    if (binaryCourseMalagHakala && binaryCourseMalagHakalaNum) {
        if (binaryCourseMalagHakalaNum > binaryCourseRectorNum) {
            binaryCourseMalagHakala.isGreater = true;
        } else if (binaryCourseMalagHakalaNum < binaryCourseRectorNum) {
            newHakalotArray.forEach(c => {
                if(c.type === RightType.Course) {
                    c.isGreater = true;
                } 
            }) 
        }
        // newHakalotArray = newHakalotArray.filter(c => c.type !== RightType.Course);
        // newHakalotArray.push(binaryCourseMalagHakala!)
    }

    if (ptorNekutorZcootMalagHakalaSum) {
        newHakalotArray.push(binaryCourseMalagHakala!)
    }

    return newHakalotArray;
}

// accordirg to the new "Mitveh" of the מל"ג
function getPtorNekudotZehutMalag(totalMiluimDays: number): CalculationResult | null {
    let zcoot = {}; 

    switch (true) {
        case totalMiluimDays < 30:
            return null;
        case totalMiluimDays >= 30 && totalMiluimDays <= 60:
            zcoot = {
                sum: MalagRights.get(MalagTimePeriods.FROM_30_UP_TO_60_DAYS)!.get(RightType.NekudotZehut),
                reason: hakalotTerms.FROM_30_UP_TO_60_DAYS_REASON,
                type: RightType.NekudotZehut,
                isMalag: true
            }; 
            return zcoot as CalculationResult;
        case totalMiluimDays >= 61 && totalMiluimDays <= 99:
            zcoot = {
                sum: MalagRights.get(MalagTimePeriods.FROM_61_UP_TO_99_DAYS)!.get(RightType.NekudotZehut),
                reason: hakalotTerms.FROM_61_UP_TO_99_DAYS_REASON,
                type: RightType.NekudotZehut,
                isMalag: true
            }; 
            return zcoot as CalculationResult;
        case totalMiluimDays >= 100:
            zcoot = {
                sum: MalagRights.get(MalagTimePeriods.FROM_100_AND_UP)!.get(RightType.NekudotZehut),
                reason: hakalotTerms.FROM_100_AND_UP_REASON,
                type: RightType.NekudotZehut,
                isMalag: true
            }; 
            return zcoot as CalculationResult;
        }
    return null;
}

// accordirg to the new "Mitveh" of the מל"ג
function getBinaryCourseNumberMalag(totalMiluimDays: number): CalculationResult | null {
    let binaryCourse = {};   
    switch (true) {
        case totalMiluimDays < 30:
            return null;
        case totalMiluimDays >= 30 && totalMiluimDays <= 60:
            binaryCourse = {
                sum: MalagRights.get(MalagTimePeriods.FROM_30_UP_TO_60_DAYS)!.get(RightType.Course),
                reason: hakalotTerms.FROM_30_UP_TO_60_DAYS_REASON,
                type: RightType.Course,
                isMalag: true
            }; 
            return binaryCourse as CalculationResult;
        case totalMiluimDays >= 61 && totalMiluimDays <= 99:
            binaryCourse = {
                sum: MalagRights.get(MalagTimePeriods.FROM_61_UP_TO_99_DAYS)!.get(RightType.Course),
                reason: hakalotTerms.FROM_61_UP_TO_99_DAYS_REASON,
                type: RightType.Course,
                isMalag: true
            }; 
            return binaryCourse as CalculationResult;
        case totalMiluimDays >= 100:
            binaryCourse = {
                sum: MalagRights.get(MalagTimePeriods.FROM_100_AND_UP)!.get(RightType.Course),
                reason: hakalotTerms.FROM_100_AND_UP_REASON,
                type: RightType.Course,
                isMalag: true
            }; 
            return binaryCourse as CalculationResult;
        }
    return null;
}

export function getOverlappingDaysNum(miluimRanges: MiluimPeriod[], includesSemesterB = false): number {
    var miluimMomentRanges = new Array();
    var sumOfOverlappingDays = 0; // with semster A

    miluimRanges.forEach(range => {
        miluimMomentRanges.push(getMomentRange(range.from, range.to))
    });

    miluimMomentRanges.forEach(momentRange => {
        // console.log(config.SEMESTER_A_PERIOD);
        var overlapRange = momentRange.intersect(config.SEMESTER_A_PERIOD)
        if (overlapRange) {
            sumOfOverlappingDays += overlapRange.diff('days') + 1;
        }

        if (includesSemesterB) {
            var overlapRange = momentRange.intersect(config.SEMESTER_B_PERIOD)
            if (overlapRange) {
                sumOfOverlappingDays += overlapRange.diff('days') + 1;
            }
        }
    });
    // console.log(sumOfOverlappingDays);
    return sumOfOverlappingDays;
}

export function getMomentRange(from: string, to: string) {
    const start = moment(from, 'DD/MM/YYYY');
    const end = moment(to, 'DD/MM/YYYY');

    return moment.range(start, end).snapTo('day');
}


function get10DaysHakala(degreeType: DegreeType): CalculationResult[] {
    let hakalot = []
    if ((degreeType === DegreeType.Boger || degreeType === DegreeType.RefuaChishuvit)) {
        let zcoot = {
            sum: 2,
            reason: hakalotTerms.TEN_DAYS_REASON,
            type: RightType.AvneyPina
        };
        hakalot.push(zcoot)
    }

    let examDoesntCount = {
        sum: -1,
        reason: hakalotTerms.TEN_DAYS_REASON,
        type: RightType.ExamDoesntCount
    }
    hakalot.push(examDoesntCount);
    return hakalot
}

export function get28DaysHakala(): CalculationResult[] {
    let testTimeExtension = {
        sum: -1,
        reason: hakalotTerms.TWENTY_EIGHT_DAYS_REASON,
        type: RightType.TestTimeExtension
    }
    return [testTimeExtension]
}

function get200DaysHakala(degreeType: DegreeType): CalculationResult[] {
    let noAttendanceRequired = {
        sum: -1,
        reason: hakalotTerms.FROM_200_AND_UP_REASON,
        type: RightType.NoAttendanceRequired
    };

    let intermediateAssignmentsPtor = {
        sum: -1,
        reason: hakalotTerms.FROM_200_AND_UP_REASON,
        type: RightType.IntermediateAssignmentsPtor
    };

    let hakalotMap = config.RightsConfig.get(true)!.get(degreeType)!.get(config.RIGHTS_OF_200_DAYS);

    let ptorBinaryCourse = {
        sum: hakalotMap!.get(RightType.Course)!,
        reason: hakalotTerms.FROM_200_AND_UP_REASON,
        type: RightType.Course
    };

    return [noAttendanceRequired, intermediateAssignmentsPtor, ptorBinaryCourse]
}

function getWeeksTwoHakala(isInMiluim: boolean, degreeType: DegreeType): CalculationResult[] {
    let rightsMap = config.RightsConfig;
    let hakalotMap = rightsMap.get(isInMiluim)!.get(degreeType)!.get(config.RIGHTS_OF_3_WEEK_SECOND);

    // let hakalot = [];
    let zcoot = {
        sum: hakalotMap!.get(RightType.NekudotZehut)!,
        reason: hakalotTerms.THREE_WEEKS_SECOND_REASON,
        type: RightType.NekudotZehut
    };

    let course = {
        sum: hakalotMap!.get(RightType.Course)!,
        reason: hakalotTerms.THREE_WEEKS_SECOND_REASON,
        type: RightType.Course
    };

    return [zcoot, course]
}

function getWeeksOneHakala(isInMiluim: boolean, degreeType: DegreeType): CalculationResult[] {
    let rightsMap = config.RightsConfig;
    let hakalotMap = rightsMap.get(isInMiluim)!.get(degreeType)!.get(config.RIGHTS_OF_3_WEEK_FIRST);

    let zcoot = {
        sum: hakalotMap!.get(RightType.NekudotZehut)!,
        reason: hakalotTerms.THREE_WEEKS_FIREST_REASON,
        type: RightType.NekudotZehut
    };

    let course = {
        sum: hakalotMap!.get(RightType.Course)!,
        reason: hakalotTerms.THREE_WEEKS_FIREST_REASON,
        type: RightType.Course
    };

    let hakalot = [zcoot, course]

    return hakalot
}

function get50DaysHakala(isInMiluim: boolean, degreeType: DegreeType): CalculationResult[] {
    let rightsMap = config.RightsConfig;
    let hakalotMap = rightsMap.get(isInMiluim)?.get(degreeType)?.get(config.RIGHTS_OF_50_DAYS);

    // let hakalot = [];
    let zcoot = {
        sum: hakalotMap!.get(RightType.NekudotZehut)!,
        reason: hakalotTerms.FIFTY_DAYS_REASON,
        type: RightType.NekudotZehut
    };

    let course = {
        sum: hakalotMap!.get(RightType.Course)!,
        reason: hakalotTerms.FIFTY_DAYS_REASON,
        type: RightType.Course
    };

    return [zcoot, course]
}

export const getFaculty = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('faculty') as (Faculty | null) || Faculty.General;
}
